import React from "react";
import * as Foot from "../style/Footer-style";
import emailIcon from "../../assets/at-details/email-icon.svg";
import phoneIcon from "../../assets/at-details/phone-icon.svg";
import locationIcon from "../../assets/at-details/adress-icon.svg";


export const FooterContact: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Foot.Footer>
      <Foot.FootRow>
        <Foot.FootListContainer>
          <Foot.FootContactH1>
            Säg{" "}
            <Foot.HighlightSpanFoot $color="#FFA0FF">
              {" "}
              hej
            </Foot.HighlightSpanFoot>{" "}
            till oss!
          </Foot.FootContactH1>

          <Foot.FootContactContainer>
 
              <Foot.FootIcon
                src={emailIcon}
                alt="Kontakta oss via e-post"
              />

            

            <Foot.FootContactInfo
              href="mailto:hello@andtech.se"
              aria-label="Send an email to hello@andtech.se"
            >
              hello@andtech.se
            </Foot.FootContactInfo>
          </Foot.FootContactContainer>

          <Foot.FootContactContainer>
            <Foot.FootIcon src={phoneIcon} alt="" />

            <Foot.FootContactInfo
              href="tel:+46703414288"
              aria-label="Call 070 34 142 88"
            >
              070 341 42 88
            </Foot.FootContactInfo>
          </Foot.FootContactContainer>

          <Foot.FootContactContainer as="address">
            <Foot.FootIcon src={locationIcon} alt="" />
            <Foot.FootContactInfoAdress>
              Bondegatan 30
              <br />
              11633 Stockholm
            </Foot.FootContactInfoAdress>
          </Foot.FootContactContainer>

          <Foot.ContactUsButton to="/om-oss/#kontakt" />
        </Foot.FootListContainer>
      </Foot.FootRow>

      <Foot.FootRow $justify="right">
        <Foot.FootLogoContainer>
          <Foot.FooterLogoMini />
          <Foot.FootP aria-label={`Copyright ${currentYear} AndTech AB`}>
            ©{currentYear}
          </Foot.FootP>
        </Foot.FootLogoContainer>
      </Foot.FootRow>
    </Foot.Footer>
  );
};
